import React from "react";
// import './WelcomeToDesktopBeta.css'
import SystemRequirementsImage from './images/system_requirements.png'

const WelcomeToDesktopBeta = ({accessToken, deeplink}) => {
    async function enterWorld() {
        window.location.href = deeplink
    }
    return ( 
        <div className="main-container ff-center" style={{display: "flex", flexDirection: "column", paddingTop: "12px"}}>
            <div>Welcome to Future Fest Desktop Beta!</div>
            <img src={SystemRequirementsImage} alt="System requirements image" />
            <button className="ff-button" onClick={enterWorld}>Enter World</button>
            <br />
            <p style={{fontSize: "smaller"}} className="connect-wallet-subtitle">Launcher still didn't download?</p>
            <span style={{fontSize: "smaller"}}><a href="https://ff-desktop-clients.s3.amazonaws.com/FutureFestLauncherSetup.exe">Download Installer</a> or <a href="https://www.futurefest.io/support" target="_blank" rel="noopener noreferrer">Click here for help</a></span>
        </div>
    );
};

export default WelcomeToDesktopBeta;
